import optionsApi from "./optionsApi";

export interface IPlanDocument {
  id?: string;
  size?: number;
  s3Url?: string;
  type?: string;
  isUserUploaded?: boolean;
  documentType?: string;
  generatedOn?: string;
  documentName?: string;
  entityId?: string;
  metaData?: {
    shownToEmployee?: boolean;
    canEmployeeDownload?: boolean;
    tags?: { label: string; value: string }[];
  };
}

export const getPlanDocuments = async (
  planId: string
): Promise<IPlanDocument[]> => {
  const response = await optionsApi.get(`/v1/plan/getPlanDocsV2`, {
    params: { planId },
  });
  return response.data?.data || [];
};

export const uploadPlanDocuments = async (payload: {
  entityId: string;
  documentType: string;
  documentName: string;
  b64File: string;
  contentType: string;
  metaData: any;
}): Promise<IPlanDocument> => {
  const response = await optionsApi.post(
    `/v1/plan/uploadPlanDocumentsV2`,
    payload
  );
  return response.data?.data;
};

export const updatePlanDocument = async (payload: {
  id: string;
  documentType?: string;
  documentName?: string;
  metaData?: any;
}): Promise<IPlanDocument> => {
  const response = await optionsApi.post(`/v1/plan/updateDocumentMetaData`, {
    data: payload,
  });
  return response.data?.data;
};

export const deletePlanDocuments = async (documentIds: string[]) => {
  const response = await optionsApi.delete(`/v1/plan/deletePlanDocuments`, {
    data: { documentIds },
  });
  return response.data;
};
